import { trigger, transition, style, animate } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { SmartListTransactionItem } from '@components/smart-list/GenericSmartList';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiTransactionService } from '@services/api-transaction.service';
import { SharedService } from '@services/shared.service';

import { SessionModel } from '@shared/models/SessionModel';
import { TransactionNotesModel } from '@shared/models/TransactionModel';
import { VendorStoreModel } from '@shared/models/VendorModel';

import { Country } from '@shared/models/Enums';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-coupon-details',
    templateUrl: './coupon-details.component.html',
    styleUrls: ['./coupon-details.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('10ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ]
})
export class CouponDetailsComponent implements OnInit {

    @Input() transactionCouponId: number;
    @Input() country: Country = Country.CR;
    @Input() preloadedSale: SmartListTransactionItem = null; //receive the data to dont call the api again
    @Output() preloadSale: EventEmitter<SmartListTransactionItem> = new EventEmitter<SmartListTransactionItem>();// send the data to preload it in the next reload
    @Output() onUpdateTransactionNote: EventEmitter<TransactionNotesModel> = new EventEmitter<TransactionNotesModel>();

    sale: SmartListTransactionItem;

    vendorStores: VendorStoreModel[] = [];

    showSendGivi = 0; // Default Canjear

    givilink: string;
    giviLinkOrigin: string;

    linkCopied = false;

    token = '';
    tokenTimerId = null;

    successRedeemId = null;
    showSuccess = false;

    currentTokenTimerMax = 18000;
    currentTokenTimerValue = 18000;

    // Note
    giviNote: TransactionNotesModel;
    transactionId: number;
    customerOwnerId: number;

    showBarcode: boolean = false;

    showDescription = false;

    session: SessionModel;

    actionOption = 1; //1 = Qr, 2 = Barras, 3 = regalar, 4 = Download
    showMoreDetails = false;
    showAllDesc = false;

    wantToRedeem = false;
    isVisible = false;

    private wantToRedeemSubscription: Subscription = null;

    constructor(public location: Location,
        public router: Router,
        public sharedService: SharedService,
        private renderer: Renderer2,
        public apiTransactionService: ApiTransactionService,
        private modalService: NgbModal
    ) { }

    ngOnInit(): void {

        //hide the qr code
        this.wantToRedeemSubscription = this.sharedService.wantToRedeemId.subscribe(x => {

            if (this.sale && this.sale.id != x) {

                clearInterval(this.tokenTimerId);
                clearInterval(this.successRedeemId);
                this.wantToRedeem = false;
            };
        });


        if (this.preloadedSale == null) this._getTransaction(this.transactionCouponId);
        else {

            this.sale = new SmartListTransactionItem(this.preloadedSale);
            this._initLoad();
        }



    }

    ngOnDestroy() {

        if (this.wantToRedeemSubscription) { this.wantToRedeemSubscription.unsubscribe(); }

        clearInterval(this.successRedeemId);
        clearInterval(this.tokenTimerId);

    }

    onChangeOption(option) {

        this.actionOption = option;

        if (option == 1) this.showBarcode = false
        if (option == 2) this.changeShowCode(true)

    }

    onChangeWantToRedeem() {

        window.addEventListener('scroll', this.handleScroll);
        this.isVisible = true;

        this.sharedService.setWantToRedeemId(this.sale.id);

        this._refreshToken();
        this._successRedeemed();

        this.wantToRedeem = true;

    }

    handleScroll = () => {

        const targetDiv = document.querySelector('#targetDiv') as HTMLElement;

        if (targetDiv) {

            const rect = targetDiv.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {

                this.isVisible = true;
            } else this.isVisible = false;
        }
    };

    changeShowCode(showBarcode) {

        this.showBarcode = showBarcode;

        if (showBarcode) {
            setTimeout(() => {
                const barcodeElement = this.renderer.selectRootElement('#barcode', true);
                if (barcodeElement) {
                    //barcode
                    /* JsBarcode(barcodeElement, `${this.sale.qrCode + '/' + this.token}`, {
                        format: "CODE128",
                        lineColor: "#000",
                        width: 2,
                        height: 150,
                        displayValue: true
                    }); */
                }
            }, 10);
        }
    }

    showGiviNote(transactionNote: TransactionNotesModel, transactionId: number, customerOwnerId: number, isExpired: boolean) {

        if (!isExpired) {
            this.giviNote = transactionNote;
            this.transactionId = transactionId;
            this.customerOwnerId = customerOwnerId;
            this.sharedService.setShowGiviNoteModalModal(true);
        }
    }

    onUpdateNote(transactionNote: TransactionNotesModel) {

        this.sale.transactionNotes = transactionNote;
        this.onUpdateTransactionNote.emit(transactionNote);
    }

    onViewTerms(modal: any) {

        this.modalService.open(modal, {
            backdrop: 'static', keyboard: false, scrollable: true,
            centered: true, windowClass: 'modal-full'
        });
    }

    onCloseSuccess() {

        //close success redeemed
        this.showSuccess = false;

        let url = this.router.url;

        this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(url);
        });
    }

    private _refreshToken() {

        // Calcular el timer
        this.currentTokenTimerMax = 5 * 60 * 60; // 5min to Seconds

        // First token
        let tokenData = this.apiTransactionService.getToken(this.sale?.id, this.currentTokenTimerMax);
        this.currentTokenTimerValue = tokenData.currentTokenTimerValue;
        this.token = tokenData.token;

        // Refresh token each 1 second
        this.tokenTimerId = setInterval(() => {

            tokenData = this.apiTransactionService.getToken(this.sale?.id, this.currentTokenTimerMax);
            this.currentTokenTimerValue = tokenData.currentTokenTimerValue;
            this.token = tokenData.token;
        }, 100);
    }

    private _getTransaction(id: number): void {

        this.apiTransactionService.getFullTransaction(id, this.country).then(
            (transaction) => {

                this.sale = new SmartListTransactionItem({
                    userId: id,
                    ...transaction
                });

                this.sale.country = this.country;

                this.preloadSale.emit(this.sale);

                this._initLoad();
            },
            (err) => {

                let errMsg = `Error al cargar información del Givi Bit`;
                if (err.status == 404) {
                    errMsg = `El Givi Bit no existe`;
                }
                // Desautorizado navigate to login
                else if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(() => {
                        this.router.navigate(['/market']);
                    });
                    return;
                }
                this.sharedService.showErrorAlert(null, errMsg).then(_x => {

                    let url = this.router.url;

                    this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
                        this.router.navigateByUrl(url);
                    });
                });
            }
        );
    }

    private _initLoad() {

        this.vendorStores = this.sale.productStores?.filter(x => x.deletedAt == null);
        this._genLink();
    }

    private _genLink() {

        const code = `CPP-${this.sale.id.toString().padStart(5, '0')}-${this.sale.customerOwnerId}`;
        let hash = window.btoa(code);

        // Remove the = symbol
        hash = hash.replace(/[=]/g, '');

        let text = `comercio=${this.sale.vendorName}`;
        // Remove the % symbol
        text = text.replace(/[%]/g, '');
        // Replace the spaces
        text = text.replace(/\s/g, '+');

        this.givilink = `${this.apiTransactionService.siteUrl}/tc/${this.session?.user?.country}/${hash}?${text}`;
        this.giviLinkOrigin = this.givilink;
        this.givilink = `${this.giviLinkOrigin}`;
    }

    private _successRedeemed() {

        //check if the coupon has been redeemedx

        this.successRedeemId = setInterval(() => {

            if (this.sale.redeemedAt === null && this.isVisible) {

                this.apiTransactionService.getBasicTransaction(this.sale.id, this.country).then(
                    (basicCoupon) => {

                        //if the coupon is actually redemeed we show a success modal 
                        //and stop de the interval
                        if (basicCoupon.redeemedAt != null) {

                            clearInterval(this.successRedeemId);

                            this.showSuccess = true;
                        }
                    }
                )
            }
        }, 1000);
    }
}
